import { gql, useMutation } from '@apollo/client';
import { useNotificationContext } from '@modules/common/components/Notification/NotificationContext';
import { LIST_CHAT_GQL } from '@modules/oracle/hooks/useFetchChatList';
import { CopyChatInput, Mutation } from 'generated/graphql';
import { useCallback } from 'react';
import { useGetUser } from 'v2/core/services/user';

const COPY_CHAT = gql`
  mutation copyChat($id: ID!, $tenantID: ID!, $userID: ID!) {
    copyChat(request: { id: $id, tenantID: $tenantID, userID: $userID }) {
      chat {
        id
        title
        viewToken
      }
    }
  }
`;

export function useCopyChat() {
  const {
    id: userID,
    tenant: { id: tenantID },
  } = useGetUser();
  const { showErrorNotification } = useNotificationContext();
  const [copyChat, resp] = useMutation<Mutation, CopyChatInput>(COPY_CHAT, {
    onError: () => {
      showErrorNotification({
        contentComponent: 'Error occurred while copying the chat.',
        props: {},
      });
    },
  });

  const copyChatCB = useCallback(
    async (id: string) => {
      return await copyChat({
        variables: {
          id,
          tenantID,
          userID,
        },
        refetchQueries: [LIST_CHAT_GQL],
      });
    },
    [tenantID, userID, copyChat],
  );

  return [
    copyChatCB,
    {
      isLoading: resp.loading,
      chat: resp.data?.copyChat?.chat,
    },
  ] as const;
}
